export interface EnderecoVo {
  id?: number;
  tipoEndereco?: string;
  logradouro: string;
  municipio: string;
  cidade?: string;
  bairro: string;
  estado: string;
  cep: string;
  zona?: string;
  latitude?: number;
  longitude?: number;
  numero?: number;
}

export const emptyEndereco = (): EnderecoVo => ({
  logradouro: '', municipio: '', bairro: '', cep: '', estado: '', latitude: undefined, longitude: undefined,
});

export const enderecoCompleto = (end: EnderecoVo): string => {
  let str = end.logradouro;
  str = end.bairro ? `${str}, ${end.bairro}` : str;
  str = end.municipio ? `${str}, ${end.municipio}` : str;
  str = end.estado ? `${str} - ${end.estado}` : str;
  return str;
};
